import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Wrapper, StyledUserBox } from './styled';
import { useState, FC, useEffect, useCallback } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from '@mui/material/Pagination';
import Create from './Create';

const getUsersURL = process.env.REACT_APP_API_URL + 'api/Account/GetUsers';
const getUserByIdURL = process.env.REACT_APP_API_URL + 'api/Account/GetUserById';

const Update: FC<{ handleBack: () => void }> = ({ handleBack }) => {
    const navigate = useNavigate();

    const [users, setUsers] = useState<
        | {
              list: [
                  {
                      id: string;
                      name: string;
                      surname: string;
                      patronymic: string;
                      organizationName: number;
                      organizationId: number;
                  },
              ];
              totalCount: number;
              expiredCount: number;
          }
        | undefined
    >(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [isSelectedUserLoading, setIsSelectedUserLoading] = useState(false);
    const [selectedUserData, setSelectedUserData] = useState<
        | {
              id: string;
              name: string;
              surname: string;
              patronymic: string;
              organizationName: number;
              organizationId: number;
              roles: string[];
          }
        | undefined
    >(undefined);
    const [pagination, setPagination] = useState(1);
    const [isNeedRefetch, setIsNeedRefetch] = useState(false);

    const paginationForURL = (pagination - 1) * 9;

    const handleUserSelect = (userId: string) => {
        setSelectedUserId(userId);
    };

    useEffect(() => {
        if (selectedUserId) {
            setIsSelectedUserLoading(true);
            axios
                .get(getUserByIdURL, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                    params: {
                        userId: selectedUserId,
                    },
                })
                .then((data) => {
                    setSelectedUserData(data.data);
                })
                .catch((err) => {
                    if (err.response.status === 401) {
                        localStorage.clear();
                        navigate('/login');
                    } else {
                        alert('Не удалось загрузить данные юзера, ' + err);
                    }
                })
                .finally(() => setIsSelectedUserLoading(false));
        }
    }, [selectedUserId]);

    const getUsers = useCallback(() => {
        axios
            .get(getUsersURL, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                params: {
                    Skip: paginationForURL,
                    Take: 9,
                },
            })
            .then((data) => {
                setUsers(data.data);
            })
            .catch((err) => {
                if (err.response.status === 401) {
                    localStorage.clear();
                    navigate('/login');
                } else {
                    alert('Не удалось загрузить список юзеров, ' + err);
                }
            })
            .finally(() => setIsLoading(false));
    }, [navigate, paginationForURL]);

    useEffect(() => {
        setIsLoading(true);
        try {
            getUsers();
        } catch (err) {
            console.log('err', err);
        }
    }, []);

    useEffect(() => {
        if (isNeedRefetch) {
            setIsLoading(true);

            try {
                getUsers();
            } catch (err) {
                console.log('err', err);
            }

            setIsNeedRefetch(false);
        }
    }, [isNeedRefetch, getUsers]);

    const handleChangePagination = (event: React.ChangeEvent<unknown>, value: number) => {
        setPagination(value);
        setIsNeedRefetch(true);
    };

    const handleUpdateBack = () => {
        setSelectedUserData(undefined);
        setSelectedUserId('');
    };

    return selectedUserData ? (
        <Create handleBack={handleUpdateBack} title='Редактирование пользователя' selectedUserData={selectedUserData} />
    ) : (
        <Wrapper>
            <Box display='flex' width='550px' justifyContent='space-evenly' alignItems='center'>
                <IconButton color='primary' onClick={handleBack}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography width='70%'>Список пользователей для редактирования</Typography>
            </Box>

            <Stack gap={1}>
                {isLoading ? (
                    <CircularProgress />
                ) : (
                    users?.list.map(({ id, surname, name, patronymic }) => (
                        <StyledUserBox
                            key={id}
                            onClick={() => !isSelectedUserLoading && handleUserSelect(id)}
                            color={isSelectedUserLoading ? 'gray' : ''}
                        >
                            <Typography>{surname + ' ' + name + ' ' + patronymic}</Typography>
                        </StyledUserBox>
                    ))
                )}
            </Stack>
            {users && !(users?.totalCount <= 9) && (
                <Pagination
                    sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 1 }}
                    count={Math.ceil(users?.totalCount / 9)}
                    variant='outlined'
                    shape='rounded'
                    onChange={handleChangePagination}
                />
            )}
        </Wrapper>
    );
};

export default Update;
